
export const SINGLECHECK_STATUS_OK = 20000;

export const SINGLECHECK_STATUS_BAD_REQUEST = 40000;
export const SINGLECHECK_STATUS_EXISTS = 40001;
export const SINGLECHECK_STATUS_VALIDATION_ERROR = 40002;
export const SINGLECHECK_STATUS_ACCT_UPDATE_ERROR = 40003;
export const SINGLECHECK_STATUS_NOT_FOUND = 40004;
export const SINGLECHECK_STATUS_VERIFICATION_FAILED = 40005;

export const SINGLECHECK_STATUS_ERROR = 50000;



// WEBPACK FOOTER //
// ./src/redux/singleCheck/status.js